import { render, staticRenderFns } from "./trans-delivery-info.html?vue&type=template&id=9e08ac38&scoped=true&external"
import script from "./trans-delivery-info.js?vue&type=script&lang=js&external"
export * from "./trans-delivery-info.js?vue&type=script&lang=js&external"
import style0 from "./trans-delivery-info.scss?vue&type=style&index=0&id=9e08ac38&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e08ac38",
  null
  
)

export default component.exports